import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const HTTP_UNAUTHORIZED = 401;
const TOKEN_KEY = 'tz_token';
const EMAIL_KEY = 'tz_email';

export const tokenStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY) || '',
  getEmail: () => localStorage.getItem(EMAIL_KEY) || '',
  set: (token, email) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(EMAIL_KEY, email);
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
  },
};

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = tokenStorage.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === HTTP_UNAUTHORIZED) {
      tokenStorage.clear();
    }
    return Promise.reject(err);
  }
);

export const absoluteAsset = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
};

export default api;
